import React from 'react';
import styled from 'styled-components';
import { BettyProvider } from '../context/BettyContext';
import { BettyChat } from '../components/Betty';

const BettyPageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #2c1810 0%, #1a0f08 100%);
  overflow: hidden;
`;

const Betty: React.FC = () => {
  return (
    <BettyPageContainer>
      <BettyProvider>
        <BettyChat />
      </BettyProvider>
    </BettyPageContainer>
  );
};

export default Betty;